import { render, staticRenderFns } from "./lastProducts.vue?vue&type=template&id=13b065fc&scoped=true&"
import script from "./lastProducts.vue?vue&type=script&lang=js&"
export * from "./lastProducts.vue?vue&type=script&lang=js&"
import style0 from "./lastProducts.vue?vue&type=style&index=0&id=13b065fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b065fc",
  null
  
)

export default component.exports